// src/navigation/breadcrumbs.ts

export type Page =
  | 'dashboard'
  | 'org-email-settings'
  | 'effort-overview'
  | 'effort-details'
  | 'users'
  | 'organization'
  | 'import-supporters'
  | 'view-supporters'
  | 'content-audit'
  | 'email-overview'
  | 'digital-body-language'
  | 'crm-admin'
  | 'login'
  | 'deliverable'
  | 'migrate-organization'
  | 'celery-tasks'
  | 'supporters-merge'
  | 'assets-manager'
  | 'survey-html'
  | 'legacy-challenge-widget'
  | 'tell-your-story-widget'
  | 'daf-widget'
  | 'daf-custodian-widget'
  | 'form-editor';

export type Crumb = {
  label: string;
  page?: Page;
  isDisabled?: boolean;
};

export function getBreadcrumbs(
  activePage: string,
  selectedEffortName?: string | null
): Crumb[] {
  switch (activePage) {
    case 'dashboard':
      return [{ label: 'Homepage', isDisabled: true }];
    case 'import-supporters':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Import supporters', isDisabled: true },
      ];
    case 'users':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'User', isDisabled: true },
      ];
    case 'organization':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Organization', isDisabled: true },
      ];
    case 'view-supporters':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'View supporters', isDisabled: true },
      ];
    case 'org-email-settings':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Email settings', isDisabled: true },
      ];
    case 'digital-body-language':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: 'Web analytics', isDisabled: true },
      ];
    case 'effort-overview':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', isDisabled: true },
      ];
    case 'effort-details':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', isDisabled: true },
      ];
    case 'deliverable':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'Deliverable', isDisabled: true },
      ];
    case 'survey-html':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'Survey', isDisabled: true },
      ];
    case 'tell-your-story-widget':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'Tell Your Story Widget', isDisabled: true },
      ];
    case 'legacy-challenge-widget':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'Legacy Challenge Widget', isDisabled: true },
      ];
    case 'daf-widget':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'DAF Effort Widget', isDisabled: true },
      ];
    case 'daf-custodian-widget':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'DAF Custodian Effort Widget', isDisabled: true },
      ];
    case 'email-overview':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Email calendar', isDisabled: true },
      ];
    case 'content-audit':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Content audit', isDisabled: true },
      ];
    case 'crm-admin':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'CRM admin', isDisabled: true },
      ];
    case 'migrate-organization':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Migrate Existing Organization', isDisabled: true },
      ];
    case 'celery-tasks':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Background Jobs', isDisabled: true },
      ];
    case 'supporters-merge':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Merge Supporters', isDisabled: true },
      ];
    case 'assets-manager':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: 'Assets Manager', isDisabled: true },
      ];
    case 'form-editor':
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Efforts', page: 'effort-overview' },
        { label: selectedEffortName ?? 'Effort', page: 'effort-details' },
        { label: 'Survey', page: 'survey-html' },
        {
          label: selectedEffortName
            ? `Editing ${selectedEffortName}`
            : 'Editing form',
          isDisabled: true,
        },
      ];
    default:
      return [
        { label: 'Homepage', page: 'dashboard' },
        { label: 'Not Found', isDisabled: true },
      ];
  }
}
